import { render, staticRenderFns } from "./SmallSignupForm.vue?vue&type=template&id=af724ffc&scoped=true&"
import script from "./SmallSignupForm.vue?vue&type=script&lang=js&"
export * from "./SmallSignupForm.vue?vue&type=script&lang=js&"
import style0 from "./SmallSignupForm.vue?vue&type=style&index=0&id=af724ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af724ffc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCheckbox,VCol,VForm,VRow,VTextField})
